import { DataOption } from '../../components'

export const INTEGRATION_TYPE = 'facebook-marketing-inbound'
export const DATA_TYPE_KEY = 'data_type'

export const FACEBOOK_MARKETING_DATA_TYPES = [
  {
    type: 'campaigns',
    label: 'Campaigns',
  },
  {
    type: 'ad_sets',
    label: 'Ad Sets',
  },
  {
    type: 'ads',
    label: 'Ads',
  },
  {
    type: 'ad_creatives',
    label: 'Ad Creatives',
  },
] as const satisfies DataOption[]
